//carousels/Bootstrap.js
"use client";
import "./carousel.css";
import { useRef, useState } from "react";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Link from "next/link";
import Slider from "react-slick";
import { APP_NAME } from "@/utils/enum";
import Image from "next/image";

export default function HeroBanner({ bannerData }: any) {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex: any, e: any) => {
    setIndex(selectedIndex);
  };
  const sliderRef = useRef<Slider | null>(null);

  const handlePrevClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const handleNextClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const app_name: string = process.env.NEXT_PUBLIC_APP_NAME || "";

  return (
    <>
      <div className="responsive-margin">
        <Carousel
          activeIndex={index}
          onSelect={handleSelect}
          indicators={true} // Ensure indicators are visible at the bottom
          prevIcon={
            <span
              onClick={handlePrevClick}
              className="carousel-control prev_a slicks-arrow d-flex justify-content-center align-items-center bg-white rounded-circle"
              style={{
                boxShadow: "-3px 3px 1rem black",
              }}
            >
              <i
                className="fa-sharp fa-light fa-angle-left"
                style={{ color: "black" }}
              ></i>
            </span>
          }
          nextIcon={
            <span
              onClick={handleNextClick}
              className="carousel-control next_a slicks-arrow d-flex justify-content-center align-items-center bg-white rounded-circle"
              style={{
                boxShadow: "3px 3px 1rem black",
              }}
            >
              <i
                className="fa-sharp fa-light fa-angle-right"
                style={{ color: "black" }}
              ></i>
            </span>
          }
        >
          {bannerData.map((item: any) => (
            <Carousel.Item
              key={item.id}
              style={{
                cursor: item.URL ? "pointer" : "default",
                position: "relative",
                overflow: "hidden",
                height: "100%",
                // backgroundColor: "red",
                // height: "300px", // Set a fixed height
              }}
            >
              <div
                style={{
                  backgroundImage: `url(${item.Image_Path})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  filter: "blur(1rem)",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 0,
                  height: "100%",
                }}
              ></div>
              <div
                className="d-flex align-items-center justify-content-center w-100 h-100"
                style={{ position: "relative", zIndex: 1 }}
              >
                {item.URL ? (
                  <Link className="d-flex w-100 h-100" href={item.URL} passHref>
                    <Image
                      src={item.Image_Path}
                      alt="Vibgyor Home Screen"
                      width={1920}
                      height={1080}
                      style={{ objectFit: "contain" }}
                    />
                  </Link>
                ) : (
                  <Image
                    src={item.Image_Path}
                    alt="Vibgyor Home Screen"
                    width={1920}
                    height={1080}
                    style={{ objectFit: "contain" }}
                  />
                )}
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
      <style jsx>{`
        .responsive-margin {
          margin-top: ${app_name == APP_NAME.VIBGYOR_VIVA ? `6rem` : `6rem`};
        }

        @media (max-width: 768px) {
          .responsive-margin {
            margin-top: ${app_name == APP_NAME.VIBGYOR_VIVA ? `7rem` : `7rem`};
          }
        }
      `}</style>
    </>
  );
}
